import { render, staticRenderFns } from "./new_report.vue?vue&type=template&id=71dbe568&scoped=true&lang=pug&"
import script from "./new_report.vue?vue&type=script&lang=js&"
export * from "./new_report.vue?vue&type=script&lang=js&"
import style0 from "./new_report.vue?vue&type=style&index=0&id=71dbe568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbe568",
  null
  
)

export default component.exports